export default __webpack_public_path__ + "static/media/BIZUDPGothic-Regular.a76f7053.ttf";